import { request } from "./index";

// AI Studio 旧接口残留：未在 OpenAPI 覆盖或为二进制下载，迁移到 defineRoute 的接口已挪到 `@apis/http/api`。

// 非 OpenAPI 路径，仍在使用：查询商品历史信息（POST /video/detail/stat/queryProductList）
const fetchVideoHistoryProduct = async <T>(reqData: unknown) => {
  return request<T>({
    method: "post",
    url: "/video/detail/stat/queryProductList",
    data: reqData,
  });
};

// 非 OpenAPI 路径，仍在使用：随机示例视频（GET /api/video/try-example）
const fetchExampleVideo = async <T>() => {
  return request<T>({
    method: "get",
    url: "/api/video/try-example",
  });
};

// 二进制响应：导出脚本分析（不通过 defineRoute 的 JSON 剥壳链路）
const downloadVideoScriptAnalysis = async (reqData: unknown) => {
  return request({
    method: "post",
    url: "/api/download/video/script-analysis",
    data: reqData,
    responseType: "blob",
  });
};

// 二进制响应：脚本生成-导出脚本
const downloadVideoScriptGenerate = async (reqData: unknown) => {
  return request({
    method: "post",
    url: "/api/download/video/script-generate",
    data: reqData,
    responseType: "blob",
  });
};

export default {
  fetchVideoHistoryProduct,
  fetchExampleVideo,
  downloadVideoScriptAnalysis,
  downloadVideoScriptGenerate,
};
